/**
 * Customers ESM entry point.
 *
 * Loaded on every customer account page via a
 * `{% if template.directory == 'customers' %}` gate in
 * content-for-footer.liquid. Covers customers/account, customers/addresses,
 * customers/login, customers/register, customers/order, customers/activate_account,
 * and customers/reset_password — only the matching delegate fires per page.
 *
 * AI: Entirely written by AI
 * Date: 2026-05-04
 * Model: Claude Opus 4.7
 *
 * [EntryCustomers]
 */

import { log } from './log.js';
import './customers.js';
import './common-customers-controller.js';

log('[App] entry-customers loaded');
